import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'usually_sound'

export default function UsuallySoundPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const formAnswer = formData.get('answer') as string

    const answer = {
      question_key: QUESTION_KEY,
      question: 'When you text someone new, how do you usually sound?',
      answer_key: formAnswer.toLowerCase(),
      answer: formAnswer,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.usuallySound.heading')}
      buttons={[
        {
          text: `👆 ${t('pages.onboarding.usuallySound.options.straightforward')}`,
          value: 'straightforward',
        },
        {
          text: `🤝 ${t('pages.onboarding.usuallySound.options.warmAndEmpathetic')}`,
          value: 'warmAndEmpathetic',
        },
        {
          text: `😀 ${t('pages.onboarding.usuallySound.options.lightheartedAndFunny')}`,
          value: 'lightheartedAndFunny',
        },
        {
          text: `😇 ${t('pages.onboarding.usuallySound.options.politeAndFormal')}`,
          value: 'politeAndFormal',
        },
      ]}
      onSubmit={onSubmit}
      headingSize="text-3xl"
      buttonTextSize="text-base"
      buttonBgColor="bg-white"
      withLogin={window.ReactNativeWebView ? false : true}
    />
  )
}
